import { METHODS } from "@app/kit";
import {
  MerchantEmployeePickResponseDTO,
  type MerchantEmployeePickScope,
  type MerchantEmployeePickSummaryDTO,
} from "@app/dto";

import { api } from "../api";
import { MOCK, mock } from "../mock";
import type { AnswerBody } from "../states/tree";

// Подбор изделий по анкете «Что искал»: ответы уходят параметрами в схему подбора 1С, в ответ — готовый
// HTML-список (как карточка сканера) и цифры. Сервер проверяет анкету и проксирует, на нём ничего не хранится.

export type PickScope = `${MerchantEmployeePickScope}`;
export type PickSummary = MerchantEmployeePickSummaryDTO;
export type PickResult = MerchantEmployeePickResponseDTO;

export interface PickBody {
  questionnaireId: string;
  scope: PickScope;
  answers: AnswerBody[];
}

const pickRequest = api.createRequest({
  url: "/v1/merchant-employee/pick",
  method: METHODS.POST,
  entity: MerchantEmployeePickResponseDTO,
});
export const pickItems = (body: PickBody): Promise<PickResult> => (MOCK ? mock.pick(body) : pickRequest({ body }));
